// export const SITE_ADDRESS = 'http://localhost:5000/';
export const SITE_ADDRESS = process.env.REACT_APP_URL;
export const SITE_ADDRESS_PEMBELAJARAN = process.env.REACT_APP_URL_PEMBELAJARAN;
export const DEEP_LINK = process.env.REACT_APP_DEEP_LINK;
export const SCHOOL_NAME = process.env.REACT_APP_SCHOOL_NAME;

export const DEMO = true;
